module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/mv_photowedding_01-ded95c8737021992d20abf2ee1c8e49a.webp";